import { AddProperty } from "shared/app/AddProperty";

export const AddPropertyPage = () => <AddProperty />;
